import styled from 'styled-components';
import { rem } from 'polished';

import Modal from '../../core/Modal';

const StyledModal = styled(Modal)`
  .legal-text {
    margin-bottom: ${rem('20px')};
  }
  .legal-text-external-title {
    text-align: center;
    margin: 2.1875rem 0 1.125rem 0;
    padding: 0 1.625rem;
  }
  .legal-acept {
    margin: 0 auto;
  }
  .legal-scroll {
    width: 100%;
    height: 50vh;
    margin-bottom: 30px;
    overflow-y: scroll;
  }
`;

export { StyledModal };
